export default __webpack_public_path__ + "static/media/three.656c171d.jpg";